import React, { PropTypes } from "react"

import styled from "styled-components"
import { Alert, Button } from "antd"
import { Link } from "react-router-dom"
const AlertStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: larger;
  text-align: center;
  p {
    text-align: center;
  }
  button {
    margin: 15px;
  }
`
class TeamsUpsellPanel extends React.Component {
  state = {
    visible: false
  }

  componentDidMount = () => {
    const { user } = this.props

    const {
      group_as_client,
      group_as_cobrand_member,
      group_as_accountant,
      group_as_enterprise_owner,
      group_as_enterprise_member
    } = user

    const isPartOfGroup =
      group_as_client ||
      group_as_cobrand_member ||
      group_as_accountant ||
      group_as_enterprise_owner ||
      group_as_enterprise_member

    setTimeout(() => {
      // TODO premium or not, show

      // if team admin or member, dont show
      if (
        user &&
        user.persona &&
        user.persona.includes("Employee") &&
        !isPartOfGroup
      )
        this.setState({ visible: true })
    }, 1000)
  }
  handleClose = () => {
    this.setState({ visible: false })
  }

  render() {
    return this.state.visible ? (
      <div
        style={{
          "box-shadow": "0 2px 14px 0 rgba(4, 25, 52, 0.1)",
          marginBottom: 20
        }}
      >
        <Alert
          description={
            <AlertStyled>
              <h3>Employee?</h3>
              <p>
                You may be looking for our <b>Teams</b> product.
              </p>
              <p>Teams is designed for companies and paid for by employers.</p>

              <Button>
                <Link to="/teams-features">Learn more</Link>
              </Button>
            </AlertStyled>
          }
          type="info"
          closable
        />
      </div>
    ) : null
  }
}

export default TeamsUpsellPanel



// WEBPACK FOOTER //
// ./src/subscriptions/TeamsUpsellPanel.jsx